export const SCREENSHOT_VIEWS = [
  {
    id: 'quick-log',
    label: 'Quick Log',
    caption:
      'Record feeds, pumping, diapers, sleep, and potty trips in seconds. Start sleep and nursing timers with one tap.',
  },
  {
    id: 'timeline',
    label: 'Timeline',
    caption:
      'Every feed, diaper, nap, potty, illness, and note in one filterable feed.',
  },
  {
    id: 'health',
    label: 'Health',
    caption:
      'Track every cold and the medicines you gave for it. Medicine schedules help you keep track of dosages.',
  },
  {
    id: 'milestones',
    label: 'Milestones',
    caption:
      "Remember every 'first'.",
  },
  {
    id: 'trends',
    label: 'Trends',
    caption:
      'WHO growth percentiles, your child\'s top foods, and sleep and diaper trends charted over time.',
  },
  {
    id: 'you',
    label: 'You',
    caption:
      'A private place to track your own mood and thoughts.',
  },
] as const;

export type ScreenshotView = (typeof SCREENSHOT_VIEWS)[number];
export type ScreenshotViewId = ScreenshotView['id'];
export type ScreenshotMode = 'light' | 'dark';

export const DEFAULT_VIEW: ScreenshotViewId = 'quick-log';

/**
 * Screenshot assets live in `public/screenshots` and are named
 * `{view}-{light|dark}.webp`, so a view id and a mode fully determine the src.
 */
export function screenshotSrc(view: ScreenshotViewId, mode: ScreenshotMode): string {
  return `/screenshots/${view}-${mode}.webp`;
}

export function screenshotAlt(view: ScreenshotViewId, mode: ScreenshotMode): string {
  const label = SCREENSHOT_VIEWS.find((v) => v.id === view)?.label ?? view;
  return `Bramble ${label} screen, ${mode} appearance`;
}
